export const API_URL = process.env.REACT_APP_API_URL ?? ''

export const ALCHEMY_API_KEY =
  (process.env.ALCHEMY_API_KEY || process.env.REACT_APP_ALCHEMY_API_KEY) ??
  'sego0RX5zqPWyegMDQ1I0eFtV48s8K2W'
